/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Workspace API
 * Workspace builder APIs for FormOps
 * OpenAPI spec version: 1.0
 */

/**
 * Plan to subscribe to for this company. Defaults to FREE when omitted.
 */
export type CreateCompanyRequestPlanKey = typeof CreateCompanyRequestPlanKey[keyof typeof CreateCompanyRequestPlanKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCompanyRequestPlanKey = {
  free: 'free',
  starter: 'starter',
  pro: 'pro',
  business: 'business',
  enterprise: 'enterprise',
} as const;
